// extracted by mini-css-extract-plugin
export var collapsedSummary = "_nt-0";